import { SxProps, Theme } from '@mui/material';
import { CSSProperties } from 'react';

/**
 * Hover/focus ring behavior for cards that navigate or act as buttons.
 * Uses a layered box-shadow ring (not border) so media stays flush to the card
 * edge — a transparent border would show as a 1px gap around the media.
 */
export const appCardInteractiveSx: SxProps<Theme> = {
  cursor: 'pointer',
  transition: 'box-shadow 0.2s ease-in-out',
  '&:hover': {
    boxShadow: (theme) => `0 0 0 1px ${theme.palette.primary.main}, ${theme.shadows[4]}`,
  },
};

/**
 * Default vertical layout for grid-style cards (media → body → footer/actions).
 */
export const appCardRootSx: SxProps<Theme> = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
};

/** Wrapper link style so the whole card inherits text color and has no underline. */
export const appCardLinkStyle: CSSProperties = {
  textDecoration: 'none',
  color: 'inherit',
  display: 'block',
};

/** Top media region: keeps aspect-friendly content from stretching the row awkwardly. */
export const appCardMediaSx: SxProps<Theme> = {
  flexShrink: 0,
  width: '100%',
  borderBottom: '1px solid',
  borderColor: 'divider',
};

/** Main body: grows to fill space between media and footer/actions. */
export const appCardContentSx: SxProps<Theme> = {
  flexGrow: 1,
};

/** Bottom action row: space-between friendly defaults; callers can override via `sx`. */
export const appCardActionsSx: SxProps<Theme> = {
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: 1,
  px: 2,
  py: 1,
  mt: 'auto',
};
